import React from 'react';

import styles from './LockCopy.module.scss';

import blackLockIcon from '../../public/images/icons/black-lock-icon.svg';
import redLockIcon from '../../public/images/icons/red-lock-icon.svg';

const { 'lock-copy': lockCopyClass } = styles;

const LockCopy = ({ color, copy }) => {
  const lockIcon = color === 'red' ? redLockIcon : blackLockIcon;
  return (
    <div className={lockCopyClass}>
      <img src={lockIcon} alt="lock icon" />
      <span>{copy}</span>
    </div>
  );
};

export default LockCopy;
